var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuariosBalken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f9f9d;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.31,9.33c0,1.96,1.83,3.56,4.07,3.56s4.06-1.6,4.06-3.56v-.89c0-1.96-1.83-3.56-4.06-3.56s-4.07,1.6-4.07,3.56v.89ZM10.34,8.44c0-.98.91-1.78,2.03-1.78s2.03.8,2.03,1.78v.89c0,.98-.91,1.78-2.03,1.78s-2.03-.8-2.03-1.78v-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.74,19.11c0-2.93-2.74-5.34-6.1-5.34h-1.28c-3.35,0-6.1,2.4-6.1,5.34h13.48ZM11.46,15.56h1.27c1.52,0,2.76.71,3.47,1.78H7.9c.71-1.07,2.03-1.78,3.56-1.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7490",
    className: "cls-1",
    d: "M19.79,0H4.21C1.88,0,0,1.88,0,4.21v15.59c0,2.32,1.88,4.2,4.21,4.21h15.59c2.32,0,4.2-1.88,4.21-4.21V4.21c0-2.32-1.88-4.2-4.21-4.21ZM21.56,19.79c0,.97-.79,1.76-1.76,1.76H4.21c-.97,0-1.76-.79-1.76-1.76,0,0,0,0,0,0V4.21c0-.97.79-1.76,1.76-1.76,0,0,0,0,0,0h15.59c.97,0,1.76.79,1.76,1.76h0v15.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuariosBalken);
export default __webpack_public_path__ + "static/media/usuarios_BALKEN.186b7330a06ec3a7576531581a2924e3.svg";
export { ForwardRef as ReactComponent };